
const digest = '05d4464d62472c9d0778c7d4d4e48cab977fff9d384868529a7c69f1acb3e83e';
const classes = {"item":"_item_18qs1_1","date":"_date_18qs1_12","patient":"_patient_18qs1_22","title":"_title_18qs1_32","content":"_content_18qs1_37","subtitle":"_subtitle_18qs1_50","controls":"_controls_18qs1_55"};
const css = `._item_18qs1_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._item_18qs1_1:first-of-type {
  border-top: 1px solid #eaedf3;
}
._item_18qs1_1 ._date_18qs1_12 {
  display: flex;
  flex-direction: column;
  border-right: 1px solid #eaedf3;
  padding: 12px 24px;
  font-size: 12px;
  font-weight: 500;
  min-width: 160px;
  max-width: 160px;
}
._item_18qs1_1 ._patient_18qs1_22 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-right: 1px solid #eaedf3;
  padding: 12px 24px;
  gap: 10px;
  min-width: 350px;
  max-width: 350px;
}
._item_18qs1_1 ._patient_18qs1_22 ._title_18qs1_32 {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}
._item_18qs1_1 ._content_18qs1_37 {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 12px 24px;
  gap: 7px;
}
._item_18qs1_1 ._content_18qs1_37 ._title_18qs1_32 {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}
._item_18qs1_1 ._content_18qs1_37 ._subtitle_18qs1_50 {
  font-size: 12px;
  font-weight: 500;
  color: #9ea0a5;
}
._item_18qs1_1 ._controls_18qs1_55 {
  min-width: 310px;
  max-width: 310px;
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  gap: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  